import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledFooter } from './Footer.styles';
export const Footer = ({ page }) => {
    return (_jsxs(StyledFooter, { "$page": page, children: [_jsx("p", { children: "\u00A9 2024 Samsung. All Rights Reserved" }), _jsx("p", { children: "Contact Us : b2b.ciam@samsung.com" })] }));
};
//# sourceMappingURL=Footer.js.map